const getIpAddress=()=>{
    fetch('https://api.ipify.org?format=json')
      .then(response => response?.json())
      .then(data => {
        localStorage.setItem("IP",data.ip);
      
      })
      .catch(error => console.error(error));
  }
  export {getIpAddress}